/* Sara Sakina scent quiz: three picture questions, scored in the browser, then the matching extrait.
   <ss-scent-quiz> runs the quiz. Links with [data-ssqz-open] and aria-controls="<dialog id>" open it as a pop-up;
   without JavaScript they simply go to the Scent quiz page. */
(() => {
  if (customElements.get('ss-scent-quiz')) return;

  const KEYS = ['qadr', 'amazight', 'safi', 'warda'];
  const STEPS = ['vibe', 'love', 'when'];
  const SCORE = {
    vibe: { warm: { qadr: 4 }, fruity: { amazight: 4 }, fresh: { safi: 4 }, floral: { warda: 4 } },
    love: { khamrah: { qadr: 5 }, cdni: { amazight: 5 }, ice: { safi: 5 }, yara: { warda: 5 }, none: {} },
    when: { day: { safi: 2, amazight: 1 }, night: { qadr: 2, warda: 1 }, both: { amazight: 2, warda: 1 } }
  };
  const PICK = { warm: 'qadr', fruity: 'amazight', fresh: 'safi', floral: 'warda', khamrah: 'qadr', cdni: 'amazight', ice: 'safi', yara: 'warda' };
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const still = () => reduce.matches || document.documentElement.classList.contains('sf-motion-paused');
  const track = (name, data) => { try { window.Shopify?.analytics?.publish?.(name, data); } catch (_) {} };
  const pathClip = !!(window.CSS && CSS.supports && CSS.supports('clip-path', 'path("M0 0H1V1Z")'));

  // The product card arch (an ogee, square at the bottom) drawn in pixels, so it keeps the card's
  // proportions on any panel size: the curve is 0.378 of the width tall.
  const arch = (w, h, inset = 0) => {
    const W = w - inset * 2;
    const a = W * 0.378;
    const x0 = inset, x1 = w - inset, y0 = inset, cx = w / 2;
    const f = n => (Math.round(n * 100) / 100).toString();
    return `M${f(x0)} ${f(h)}V${f(y0 + a)}C${f(x0)} ${f(y0 + a * 0.42)} ${f(x0 + W * 0.34)} ${f(y0 + a * 0.387)} ${f(cx)} ${f(y0)}C${f(x1 - W * 0.34)} ${f(y0 + a * 0.387)} ${f(x1)} ${f(y0 + a * 0.42)} ${f(x1)} ${f(y0 + a)}V${f(h)}Z`;
  };

  class SSScentQuiz extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.mode = this.dataset.mode || 'page';
      this.dialog = this.closest('dialog');
      this.lines = this.querySelector('.ssqz-lines');
      this.line = this.querySelector('.ssqz-line');
      this.body = this.querySelector('[data-qz-body]');
      this.steps = STEPS.map(id => this.querySelector(`[data-qz-step="${id}"]`));
      this.result = this.querySelector('[data-qz-result]');
      this.dots = Array.from(this.querySelectorAll('.ssqz-progress li'));
      this.count = this.querySelector('[data-qz-count]');
      this.back = this.querySelector('[data-qz-back]');
      this.answers = {};
      this.step = 0;
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('submit', event => this.onSubmit(event));
      if ('ResizeObserver' in window) {
        this.resizer = new ResizeObserver(() => this.shape());
        this.resizer.observe(this);
      }
      this.shape();
      if (this.dialog) {
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.closeDialog(); });
        this.dialog.addEventListener('close', () => {
          this.dialog.classList.remove('is-closing');
          document.documentElement.classList.remove('ssqz-locked');
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        });
      }
      this.show(0, false);
      this.dataset.readyState = 'ready';
      this.onHash = () => this.deepLink();
      if (this.mode === 'dialog') window.addEventListener('hashchange', this.onHash);
      this.deepLink();
    }

    disconnectedCallback() {
      this.resizer?.disconnect();
      if (this.onHash) window.removeEventListener('hashchange', this.onHash);
    }

    shape() {
      const w = this.clientWidth, h = this.clientHeight;
      if (!w || !h || (w === this.sizeW && h === this.sizeH)) return;
      this.sizeW = w; this.sizeH = h;
      const pw = w - 4, ph = h - 2;
      if (pathClip) {
        this.style.setProperty('--qz-outer', `path("${arch(w, h)}")`);
        this.style.setProperty('--qz-inner', `path("${arch(pw, ph)}")`);
      }
      this.style.setProperty('--qz-a', (pw * 0.378).toFixed(1) + 'px');
      if (this.lines && this.line) {
        this.lines.setAttribute('viewBox', `0 0 ${pw} ${ph}`);
        this.line.setAttribute('d', arch(pw, ph + 40, 9));
      }
    }

    deepLink() {
      const hash = location.hash;
      if (this.mode === 'dialog') {
        if (hash === '#scent-quiz' && this.dialog) {
          try { history.replaceState(null, '', location.pathname + location.search); } catch (_) {}
          const open = () => this.openDialog(document.querySelector(`[aria-controls="${this.dialog.id}"]`));
          const css = document.querySelector('link[href*="ss-quiz.css"]');
          if (css && css.media !== 'all' && !css.sheet) css.addEventListener('load', open, { once: true });
          else open();
        }
        return;
      }
      const match = (hash.match(/^#match-(qadr|amazight|safi|warda)$/) || [])[1];
      if (match && this.querySelector(`[data-qz-match="${match}"]`)) { this.top = match; this.reveal(match, KEYS.find(key => key !== match && this.querySelector(`[data-qz-match="${key}"]`))); return; }
      if (/^#start(-[a-z]+)?$/.test(hash)) {
        try { history.replaceState(null, '', location.pathname + location.search); } catch (_) {}
        this.scrollIntoView({ block: 'center', behavior: still() ? 'auto' : 'smooth' });
        this.steps[0].querySelector('.ssqz-q')?.focus({ preventScroll: true });
      }
    }

    show(index, focus = true) {
      this.step = index;
      const done = index >= STEPS.length;
      this.classList.toggle('is-result', done);
      this.steps.forEach((step, i) => {
        step.hidden = i !== index;
        step.classList.remove('is-current');
      });
      this.result.hidden = !done;
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-done', i < index);
        dot.classList.toggle('is-current', i === index);
      });
      if (this.back) this.back.hidden = index === 0 || done;
      if (done) return;
      const step = this.steps[index];
      const chosen = this.answers[STEPS[index]];
      step.querySelectorAll('[aria-pressed]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.v === chosen)));
      void step.offsetWidth;
      step.classList.add('is-current');
      if (this.count) this.count.textContent = `Question ${index + 1} of ${STEPS.length}`;
      if (this.body) this.body.scrollTop = 0;
      if (focus) step.querySelector('.ssqz-q')?.focus({ preventScroll: true });
    }

    onClick(event) {
      const option = event.target.closest('.ssqz-opt, .ssqz-none');
      if (option && this.contains(option)) { this.choose(option); return; }
      if (event.target.closest('[data-qz-back]')) { if (this.step > 0 && !this.busy) this.show(this.step - 1); return; }
      if (event.target.closest('[data-qz-restart]')) { this.restart(); return; }
      if (event.target.closest('[data-qz-close]')) { this.closeDialog(); return; }
      const alt = event.target.closest('[data-qz-alt-btn]');
      if (alt) { this.reveal(alt.dataset.key, this.current); return; }
      // The clipped corners beside the arch count as outside the pop-up
      if (this.dialog && event.target === this) this.closeDialog();
    }

    choose(button) {
      if (this.busy) return;
      const id = STEPS[this.step];
      if (!id) return;
      this.answers[id] = button.dataset.v;
      this.steps[this.step].querySelectorAll('[aria-pressed]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      if (this.step === 0 && !this.begun) { this.begun = true; track('ss_scent_quiz_start', { source: this.mode }); }
      this.busy = true;
      setTimeout(() => {
        this.busy = false;
        if (this.step < STEPS.length - 1) this.show(this.step + 1);
        else this.finish();
      }, still() ? 140 : 430);
    }

    finish() {
      const total = Object.fromEntries(KEYS.map(key => [key, 0]));
      STEPS.forEach(id => Object.entries(SCORE[id][this.answers[id]] || {}).forEach(([key, points]) => { total[key] += points; }));
      const order = [PICK[this.answers.love], PICK[this.answers.vibe]].filter(Boolean);
      const tie = key => { const i = order.indexOf(key); return i < 0 ? 9 : i; };
      const shown = KEYS.filter(key => this.querySelector(`[data-qz-match="${key}"]`));
      const ranked = shown.sort((a, b) => (total[b] - total[a]) || (tie(a) - tie(b)) || (KEYS.indexOf(a) - KEYS.indexOf(b)));
      if (!ranked.length) return;
      this.top = ranked[0];
      track('ss_scent_quiz_result', { match: ranked[0], second: ranked[1] || '', answers: STEPS.map(id => this.answers[id] || '').join(','), source: this.mode });
      this.reveal(ranked[0], ranked[1]);
    }

    reveal(key, second) {
      this.show(STEPS.length, false);
      this.current = key;
      let card = null;
      this.querySelectorAll('[data-qz-match]').forEach(match => {
        const on = match.dataset.qzMatch === key;
        match.hidden = !on;
        match.classList.remove('is-in');
        if (on) card = match;
      });
      if (card) {
        const kicker = card.querySelector('[data-qz-kicker]');
        if (kicker) kicker.textContent = !this.top || key === this.top ? 'Your match' : 'Also for you';
        void card.offsetWidth;
        card.classList.add('is-in');
      }
      const altWrap = this.querySelector('[data-qz-alt]');
      const altButton = this.querySelector('[data-qz-alt-btn]');
      const alt = second && second !== key ? this.querySelector(`[data-qz-match="${second}"]`) : null;
      if (altWrap && altButton && alt) {
        const bottle = alt.querySelector('.ssqz-bottle');
        const name = alt.querySelector('.ssqz-name')?.textContent.trim() || second;
        altButton.dataset.key = second;
        altButton.style.setProperty('--c2', alt.style.getPropertyValue('--c'));
        altButton.replaceChildren();
        const frame = document.createElement('span'); frame.className = 'ssqz-alt__arch'; frame.setAttribute('aria-hidden', 'true');
        const inner = document.createElement('span');
        const image = document.createElement('img');
        image.src = bottle?.currentSrc || bottle?.src || ''; image.alt = ''; image.width = 54; image.height = 81;
        inner.append(image); frame.append(inner);
        const label = document.createElement('span'); label.textContent = name;
        altButton.append(frame, label);
        altWrap.hidden = false;
      } else if (altWrap) altWrap.hidden = true;
      if (this.body) this.body.scrollTop = 0;
      card?.focus({ preventScroll: true });
      if (this.mode === 'page') { try { history.replaceState(null, '', '#match-' + key); } catch (_) {} }
    }

    restart() {
      this.answers = {};
      this.begun = false;
      this.top = null;
      this.querySelectorAll('[data-qz-match]').forEach(match => { match.hidden = true; match.classList.remove('is-in'); });
      if (this.mode === 'page') { try { history.replaceState(null, '', location.pathname + location.search); } catch (_) {} }
      this.show(0);
    }

    openDialog(opener) {
      const dialog = this.dialog;
      if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
      this.opener = opener || document.activeElement;
      document.documentElement.classList.add('ssqz-locked');
      dialog.showModal();
      this.sizeW = 0;
      this.shape();
      this.querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
      const target = this.step >= STEPS.length ? this.querySelector('[data-qz-match]:not([hidden])') : this.steps[this.step]?.querySelector('.ssqz-q');
      target?.focus({ preventScroll: true });
      track('ss_scent_quiz_open', { source: 'popup' });
    }

    closeDialog() {
      const dialog = this.dialog;
      if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
      if (still()) { dialog.close(); return; }
      dialog.classList.add('is-closing');
      setTimeout(() => { if (dialog.open) dialog.close(); dialog.classList.remove('is-closing'); }, 240);
    }

    onSubmit(event) {
      const form = event.target;
      if (form.matches('.sf-add-form')) { track('ss_scent_quiz_add', { item: form.id, source: this.mode }); return; }
      if (!form.matches('[data-qz-set]')) return;
      event.preventDefault();
      if (form.dataset.busy) return;
      const button = form.querySelector('[data-qz-add="set"]');
      const error = form.querySelector('[data-qz-set-error]');
      form.dataset.busy = 'true';
      if (button) button.disabled = true;
      if (error) error.hidden = true;
      const data = new FormData(form);
      const items = [0, 1, 2, 3].map(i => ({ id: Number(data.get(`items[${i}][id]`)), quantity: 1 })).filter(item => item.id);
      track('ss_scent_quiz_add', { item: 'tester-set', source: this.mode });
      fetch(form.action.replace(/\/?$/, '.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
        .then(response => response.json().then(json => { if (!response.ok || json.status >= 400) throw new Error(json.description || json.message || 'Could not add to bag'); }))
        .then(() => { this.querySelector('[data-open-cart]')?.click(); })
        .catch(problem => { if (error) { error.textContent = problem.message; error.hidden = false; } })
        .finally(() => { delete form.dataset.busy; if (button) button.disabled = false; });
    }
  }

  customElements.define('ss-scent-quiz', SSScentQuiz);

  // Pop-up openers. Without this script they are plain links to the Scent quiz page.
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-ssqz-open]');
    if (!opener || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    const dialog = document.getElementById(opener.getAttribute('aria-controls') || '');
    const quiz = dialog?.querySelector('ss-scent-quiz');
    if (!quiz || typeof quiz.openDialog !== 'function' || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    quiz.openDialog(opener);
  });
})();
